export const QUERY_MATERIAL = {
    MATERIAL_ID: 'materialId',
    RATING_VALUE: 'ratingValue',
    FIRST_TIME: 'firstTime',
    RATING: 'rating',
    DAYS: 'days',
    CREATE_AS_DRAFT: 'createAsDraft',
} as const;
